var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentstabicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.1095L11.1538 13.7634L12.4866 12.4306L14.4905 14.4345L18.4983 10.4267L19.85 11.7595L14.5 17.1095ZM9.45238 14.2738C9.45185 13.1574 9.73397 12.0591 10.2724 11.0813C10.8109 10.1034 11.5882 9.27776 12.5319 8.68135C13.4756 8.08495 14.5549 7.73719 15.6692 7.67049C16.7836 7.60378 17.8967 7.82031 18.9048 8.29988V1.98569C18.9048 0.945929 18.054 0.0952148 17.0143 0.0952148H1.89048C0.850714 0.0952148 0 0.945929 0 1.98569V19L3.78095 15.219H9.45238C9.45238 15.0583 9.46183 14.9071 9.48074 14.7464C9.46159 14.5896 9.45212 14.4318 9.45238 14.2738Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentstabicon);
export default __webpack_public_path__ + "static/media/Comments tab icon.7c07a8586ed854accc001660e679401c.svg";
export { ForwardRef as ReactComponent };